import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DelayService {
  public async delay(milliseconds: number): Promise<void> {
    return new Promise<void>((resolve) => setTimeout(resolve, milliseconds));
  }
}
